// @flow

const zIndices = {
  debugPinImpressions: 999,
  max: 9999,
  pinActionWrapper: 101, // indexed to 101 bc onetap overlay is 100
  saved: 102, // set above pinActionWrapper
  storyPinImage: -1,
};

export default zIndices;
